import { initialSendEmailState } from './../shared/constants'
import {
  ILoadingMessageRecipient,
  SendMessageStateEnum,
  SendMessageStatusEnum,
} from 'shared/models/Message'
import {
  SEND_EMAIL_CLOSE,
  SEND_EMAIL_OPEN,
  SEND_EMAIL_REQUESTED,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_ERROR,
  SEND_EMAIL_RESET,
  SEND_EMAIL_CREATE_DRAFT_SUCCESS,
  SEND_EMAIL_UPDATE_DRAFT_SUCCESS,
  SEND_EMAIL_IS_COLLAPSED,
  SEND_EMAIL_UPDATE_ATTACHMENTS_REQUESTED,
  SEND_EMAIL_UPDATE_ATTACHMENTS_SUCCESS,
  SEND_EMAIL_UPDATE_ATTACHMENTS_ERROR,
  SEND_EMAIL_REPLY_OR_FORWARD_REQUESTED,
  SEND_EMAIL_REPLY_OR_FORWARD_SUCCESS,
  SEND_EMAIL_REPLY_OR_FORWARD_ERROR,
  SEND_EMAIL_UPDATE_DRAFT_REQUESTED,
  SEND_EMAIL_SET_STATE,
  SEND_EMAIL_SET_CREATE_CONTACT,
  SEND_EMAIL_CREATE_CONTACT_REQUESTED,
  SEND_EMAIL_CREATE_CONTACT_SUCCESS,
  SEND_EMAIL_CREATE_CONTACT_FAILED,
  SEND_EMAIL_UPDATE_RECIPIENTS_SUCCESS,
  SEND_EMAIL_REMOVE_RECIPIENT_SUCCESS,
  SEND_EMAIL_UPDATE_MANY_RECIPIENTS_SUCCESS,
  SEND_EMAIL_FETCH_RECIEPT_ERROR,
  SEND_EMAIL_FETCH_RECIEPT_REQUESTED,
  SEND_EMAIL_FETCH_RECIEPT_SUCCESS,
  SEND_EMAIL_UPDATE_SENDING_STATUS_SUCCESS,
  SEND_EMAIL_UPDATE_SENDING_STATUS_ERROR,
  SEND_EMAIL_RECIPIENTS_TO_LOADING_LIST_REQUESTED,
  SEND_EMAIL_RECIPIENTS_TO_LOADING_LIST_SUCCESS,
  SEND_EMAIL_REFETCH_SENDING_STATUS_SUCCESS,
  SEND_EMAIL_IS_DRAFT_UPDATING,
} from './actionTypes'
import { SendEmailActionTypes } from './types'
import { produce } from 'immer'

const initial = initialSendEmailState

const initialState = initial

const reducer = (state = initialState, action: SendEmailActionTypes) => {
  switch (action.type) {
    case SEND_EMAIL_OPEN:
      return produce(state, (draft) => {
        draft.state = SendMessageStateEnum.send
        draft.message = action.payload?.message || (null as any)
        draft.messageId = action.payload?.draftId || null
        draft.isEditDraft = !!action.payload?.draftId
      })
    case SEND_EMAIL_CLOSE:
      return produce(state, (draft) => {
        draft.state = null
      })
    case SEND_EMAIL_SET_STATE:
      return produce(state, (draft) => {
        draft.state = action.payload
      })
    case SEND_EMAIL_IS_COLLAPSED:
      return { ...state, isCollapsed: action.payload }
    case SEND_EMAIL_REQUESTED:
      return { ...state, processing: true }
    case SEND_EMAIL_SUCCESS:
      return produce(state, (draft) => {
        draft.processing = false
        draft.state = SendMessageStateEnum.reciept
      })
    case SEND_EMAIL_ERROR:
      return { ...state, processing: false, error: action.payload }

    case SEND_EMAIL_REPLY_OR_FORWARD_REQUESTED:
      return produce(state, (draft) => {
        draft.state = SendMessageStateEnum.send
        draft.loading = true
      })
    case SEND_EMAIL_REPLY_OR_FORWARD_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false
        draft.message = action.payload
        draft.messageId = action.payload.id
      })
    case SEND_EMAIL_REPLY_OR_FORWARD_ERROR:
      return produce(state, (draft) => {
        draft.loading = false
        draft.error = action.payload
      })
    case SEND_EMAIL_CREATE_DRAFT_SUCCESS:
      return {
        ...state,
        message: action.payload.message,
        messageId: action.payload.id,
      }
    case SEND_EMAIL_UPDATE_DRAFT_REQUESTED:
      return produce(state, (draft) => {
        draft.isDraftUpdated = true
      })
    case SEND_EMAIL_UPDATE_DRAFT_SUCCESS:
      return produce(state, (draft) => {
        if (draft.message)
          draft.message[action.payload.field] = action.payload.value
      })

    case SEND_EMAIL_UPDATE_ATTACHMENTS_REQUESTED:
      return { ...state, savingAttachments: true }
    case SEND_EMAIL_UPDATE_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        savingAttachments: false,
        isDraftUpdated: true,
        message: {
          ...state.message,
          attachments: action.payload.allFiles,
        },
        error: action.payload.invalidUploaded
          ? 'En eller flere av filtypene du lastet opp støttes ikke av sikkerhetsmessige årsaker'
          : null,
      }
    case SEND_EMAIL_UPDATE_ATTACHMENTS_ERROR:
      return { ...state, savingAttachments: false, error: action.payload }

    case SEND_EMAIL_FETCH_RECIEPT_REQUESTED:
      return produce(state, (draft) => {
        draft.reciept.loading = true
        draft.reciept.error = null
        draft.reciept.messageId = action.payload
      })
    case SEND_EMAIL_FETCH_RECIEPT_SUCCESS:
      return produce(state, (draft) => {
        draft.reciept.data = action.payload
        draft.reciept.loading = false
      })
    case SEND_EMAIL_FETCH_RECIEPT_ERROR:
      return produce(state, (draft) => {
        draft.reciept.loading = false
        draft.reciept.error = action.payload
      })
    case SEND_EMAIL_UPDATE_SENDING_STATUS_SUCCESS:
      return produce(state, (draft) => {
        if (draft.reciept.data)
          draft.reciept.data.sendingStatus = SendMessageStatusEnum.Sent
      })
    case SEND_EMAIL_UPDATE_SENDING_STATUS_ERROR:
      return produce(state, (draft) => {
        draft.reciept.loading = false
        draft.reciept.error = action.payload
        if (draft.reciept.data)
          draft.reciept.data.sendingStatus = SendMessageStatusEnum.Error
      })
    case SEND_EMAIL_REFETCH_SENDING_STATUS_SUCCESS:
      return produce(state, (draft) => {
        if (draft.reciept.data)
          draft.reciept.data.sendingStatus = action.payload
      })

    case SEND_EMAIL_SET_CREATE_CONTACT:
      return produce(state, (draft) => {
        draft.reciept.createContact = action.payload
        draft.reciept.error = null
      })
    case SEND_EMAIL_CREATE_CONTACT_REQUESTED:
      return produce(state, (draft) => {
        draft.reciept.processing = true
      })
    case SEND_EMAIL_CREATE_CONTACT_SUCCESS:
      return produce(state, (draft) => {
        draft.reciept.createContact = null
        draft.reciept.processing = false

        const updated = draft.reciept?.data?.recipients?.find(
          (x) =>
            x.email === action.payload.email ||
            x.phonenumber === action.payload.mobile
        )
        if (updated) updated.isAdded = true
      })
    case SEND_EMAIL_CREATE_CONTACT_FAILED:
      return produce(state, (draft) => {
        draft.reciept.processing = false
        draft.reciept.error = action.payload
      })

    case SEND_EMAIL_UPDATE_RECIPIENTS_SUCCESS: {
      return produce(state, (draft) => {
        draft.isDraftUpdated = true

        if (!draft.message.recipients?.length) {
          draft.message.recipients = [action.payload]
          return
        }

        // Avoid duplicates from already existing recipients list
        const existing = draft.message.recipients.find(
          (x) => x.email?.toLowerCase() === action.payload.email?.toLowerCase()
        )

        if (existing && existing.recipientType === action.payload.recipientType)
          return

        draft.message.recipients = [...draft.message.recipients, action.payload]
      })
    }

    case SEND_EMAIL_UPDATE_MANY_RECIPIENTS_SUCCESS: {
      return produce(state, (draft) => {
        draft.isDraftUpdated = true

        if (!draft.message.recipients?.length) {
          draft.message.recipients = action.payload
          return
        }

        // Avoid duplicates from already existing recipients and incoming payload
        const recipients = [
          ...draft.message.recipients,
          ...action.payload.filter(
            (x) =>
              !draft.message.recipients?.find(
                (y) =>
                  (y.nameregisterId === x.nameregisterId ||
                    (!y.nameregisterId && y.email === x.email)) &&
                  y.recipientType === x.recipientType
              )
          ),
        ]

        draft.message.recipients = recipients
      })
    }

    case SEND_EMAIL_REMOVE_RECIPIENT_SUCCESS: {
      return produce(state, (draft) => {
        draft.isDraftUpdated = true
        // Filter away using action payload id or email
        draft.message.recipients = draft.message.recipients?.filter(
          (x) =>
            x.nameregisterId !== action.payload.nameregisterId ||
            x.recipientType !== action.payload.recipientType ||
            (x.email !== action.payload.email && Boolean(x.email))
        )
      })
    }

    case SEND_EMAIL_RECIPIENTS_TO_LOADING_LIST_REQUESTED: {
      return produce(state, (draft) => {
        draft.recipientLoadingQueue = action.payload
      })
    }

    case SEND_EMAIL_RECIPIENTS_TO_LOADING_LIST_SUCCESS: {
      return produce(state, (draft) => {
        // Remove from loading queue that has the same id from the payload
        draft.recipientLoadingQueue = draft.recipientLoadingQueue?.filter(
          (x) =>
            !action.payload.some(
              (y: ILoadingMessageRecipient) =>
                y.id === x.id &&
                y.type === x.type &&
                y.recipientType === x.recipientType
            )
        )
      })
    }

    case SEND_EMAIL_RESET:
      return initial
    case SEND_EMAIL_IS_DRAFT_UPDATING: {
      return produce(state, (draft) => {
        draft.isDraftUpdating = action.payload
      })
    }
    default:
      return state
  }
}

export default reducer
